import { render, staticRenderFns } from "./checkOrder.vue?vue&type=template&id=cb646dba&scoped=true&"
import script from "./checkOrder.vue?vue&type=script&lang=js&"
export * from "./checkOrder.vue?vue&type=script&lang=js&"
import style0 from "./checkOrder.vue?vue&type=style&index=0&id=cb646dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb646dba",
  null
  
)

export default component.exports